import React from 'react';
import classes from "./AndroidGames.module.css";
import { FaArrowRight } from 'react-icons/fa6';
import { Swiper, SwiperSlide } from "swiper/react";
import {
    Autoplay,
    Navigation,
    Pagination,
    Scrollbar,
    A11y,
    Keyboard,
    EffectCoverflow,
} from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const AndroidGames = ({ androidGames }) => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    return (
        <section className={classes.games_carousel}>
            <div className={classes.games_carousel_header}>
                {/* <h1 className={classes.games_carousel_title}>{game?.category?.category_name} Games</h1> */}

                <div className={classes.section_heading_top}>
                    <span className={classes.section_badge}>{t("120")} {t("63")}</span>
                    <span className={classes.section_line}></span>
                </div>

                <button className={classes.game_carousel_header_button}

                    onClick={() => navigate("/category", {
                        state: {
                            category_id: -1
                        }
                    })}
                >
                    <FaArrowRight className={classes.game_carousel_link_arrow} />
                </button>

            </div>
            <h2 className={classes.section_title}>
                {t("64")} <span>{t("120")}</span> {t("63")}
            </h2>

            <div className={classes.games_carousel_sub_section}>
                <Swiper
                    modules={[
                        Autoplay,
                        Navigation,
                        Keyboard
                    ]}
                    slidesPerGroupSkip={1}
                    grabCursor={true}
                    keyboard={{
                        enabled: true,
                    }}
                    loop
                    spaceBetween={8}
                    // slidesPerView={3}
                    slidesPerView={'auto'}
                    autoplay={{
                        delay: 1000,
                        disableOnInteraction: false,
                    }}
                    // navigation={{
                    //     prevEl: ".custom-swiper-prev",
                    //     nextEl: ".custom-swiper-next",
                    // }}
                    onSwiper={(swiper) => null}
                    onSlideChange={() => null}
                >
                    {androidGames?.map((g, index) => (
                        <SwiperSlide className={classes.game_carousel_container_slide_2} key={index}
                        // onClick={() => handleNavigate(g?.game_url)}
                        >
                            <div className={classes.game_carousel_container_2}>
                                <div className={classes.game_carousel_image_2}>
                                    <img src={g?.game_banner} alt={g?.game_name}
                                        loading='lazy'
                                        className={classes.game_carousel_img_2} />
                                </div>
                                <p className={classes.game_carousel_title_2}>
                                    {g?.game_name}
                                </p>

                                <button type="button" className={classes.hero_play_button}
                                    onClick={() => {
                                        window.location.href = g.game_url
                                    }}
                                >
                                    {t("121")}
                                </button>
                            </div>
                        </SwiperSlide>
                    ))}

                </Swiper>
            </div>

        </section>
    )
}

export default AndroidGames